// material-ui
import { styled, Theme, CSSObject } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH } from 'config';

const openedMixin = (theme: Theme) =>
  ({
    width: DRAWER_WIDTH,
    margin: 0,
    borderRadius: 0,
    height: '100vh',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    overflowX: 'hidden',
    boxShadow: 'none',
    '& .MuiDrawer-paper': {
      width: DRAWER_WIDTH,
      borderRadius: 0,
      boxShadow: 'none',
      height: '100vh',
      margin: 0,
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    }
  }) as CSSObject;

const closedMixin = (theme: Theme) =>
  ({
    width: theme.spacing(7.5),
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    margin: 0,
    borderRadius: 0,
    height: '100vh',
    boxShadow: 'none',
    '& .MuiDrawer-paper': {
      width: theme.spacing(7.5),
      borderRadius: 0,
      boxShadow: 'none',
      height: '100vh',
      margin: 0,
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  }) as CSSObject;

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  variants: [
    {
      props: ({ open }) => open,
      style: openedMixin(theme)
    },
    {
      props: ({ open }) => !open,
      style: closedMixin(theme)
    }
  ]
}));

export default MiniDrawerStyled;
